import { useEffect, useState } from "react";

const getCookie = (name: string): string | undefined => {
  if (typeof document === "undefined") return undefined;
  const match = document.cookie.match(new RegExp('(?:^|; )' + encodeURIComponent(name) + '=([^;]*)'));
  return match ? decodeURIComponent(match[1]) : undefined;
};

/**
 * useCookie - 获取 cookie 中指定字段的值
 * @param name cookie字段名
 * @returns 字段值或 undefined
 */
export function useCookie(name: string) {
  const [value, setValue] = useState<string | undefined>(undefined);

  useEffect(() => {
    setValue(getCookie(name));
  }, [name]);

  return value;
}
